const module = {
    namespaced: true,
    state: () => ({
        formData:{
            signature:null
        }
    }),
    getters: {
        formData(state) {
            return state.formData;
        },
    },
    mutations: {
        setFormData(state, formData) {
            state.formData = formData;
        },
        clearFormData(state) {
            state.formData = {};
        },
    },
    actions: {
        saveFormData({ commit }, formData) {
            commit('setFormData', formData);
        },
        deleteFormData({ commit }) {
            commit('clearFormData');
        },
    },
};


export default module;
